import { useForm } from "react-hook-form";

export type EndAssignmentFormValues = {
  notes: string;
};

const DEFAULTS: EndAssignmentFormValues = {
  notes: "",
};

export function useEndAssignmentForm() {
  return useForm<EndAssignmentFormValues>({ defaultValues: DEFAULTS });
}
